import { fetchOrderDetail } from '../api/ordersApi';
import { changeOrderStatus } from '../api/orderStatusApi';
import { getStatusAfterWzIssued } from './orderProcessSteps';

export type OrderStatusAfterWzRelease = 'moved' | 'unchanged' | 'refused';

/**
 * Single home for „a WZ released outside the ZK card moves the order” (owner
 * 2026-10-27, szkic WZ przed PZ): „Rozlicz wydanie” / „Zapisz i wydaj” on the
 * WZ card (WZDetail) and „Zapisz i wydaj” in the order-bound WZ form (WZNew)
 * move the customer order to „W dostawie” by the same rule as „Wystaw WZ” on
 * the ZK card (FF.10, `getStatusAfterWzIssued`; the ZK card applies it in
 * OrderDetail `handleWzIssued`). The status is informational, so a refused
 * change never undoes the release: the caller tells the operator ('refused').
 */
export async function moveOrderAfterWzRelease(orderId: string, notes: string): Promise<OrderStatusAfterWzRelease> {
  try {
    const order = await fetchOrderDetail(orderId);
    const next = getStatusAfterWzIssued(order?.status, true);
    if (!next) return 'unchanged';
    await changeOrderStatus(orderId, { status: next, notes });
    return 'moved';
  } catch (error) {
    console.warn('Order status after WZ release not changed:', error);
    return 'refused';
  }
}
